import { createEntityAdapter } from '@reduxjs/toolkit';
import { SavedSearchCriteriaResponse } from 'types/entity';

export const searchCriteriaUpdateAdaptor = createEntityAdapter<SavedSearchCriteriaResponse>({
  selectId: (model) => model.search_criteria_id,
  sortComparer: (e1, e2) => {
    if (e1.search_criteria_id > e2.search_criteria_id) {
      return 1;
    }
    return e1.search_criteria_id === e2.search_criteria_id ? 0 : -1;
  },
});
